import { SvgBase } from "../svg.base";

export const ShareFill = () => (
  <SvgBase
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill="#FFF"
      d="M17.625 3.225C19.71 3.225 21.4 4.915 21.4 7s-1.69 3.775-3.775 3.775c-1.37 0-2.569-.73-3.23-1.82l-4.318 1.678c.048.24.073.488.073.742 0 .377-.055.74-.158 1.084l4.596 2.298c.688-.93 1.792-1.532 3.037-1.532 2.085 0 3.775 1.69 3.775 3.775s-1.69 3.775-3.775 3.775S13.85 19.085 13.85 17c0-.376.055-.738.157-1.08l-4.598-2.298c-.688.927-1.79 1.528-3.034 1.528-2.085 0-3.775-1.69-3.775-3.775S4.29 7.6 6.375 7.6c1.37 0 2.57.73 3.23 1.821l4.318-1.678c-.048-.24-.073-.489-.073-.743 0-2.085 1.69-3.775 3.775-3.775z"
    />
  </SvgBase>
);